import { render, staticRenderFns } from "./FillerBetaDesigner.vue?vue&type=template&id=1be45d70&scoped=true&"
import script from "./FillerBetaDesigner.vue?vue&type=script&lang=ts&"
export * from "./FillerBetaDesigner.vue?vue&type=script&lang=ts&"
import style0 from "./FillerBetaDesigner.vue?vue&type=style&index=0&id=1be45d70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be45d70",
  null
  
)

export default component.exports